import common from '@/services/Api/common';
import StorageHelper from '@/utils/storageHelper';

let postPromise = null;
const clientIdStorage = new StorageHelper({
  id: process.env.VUE_APP_STORAGE_PMAKTIF_CLIENT_ID,
});
const clientIdPostedFlagStorage = new StorageHelper({
  id: process.env.VUE_APP_STORAGE_PMAKTIF_CLIENT_ID_POSTED_FLAG,
});

export function getOrCreateClientId() {
  let clientId = clientIdStorage.get();

  if (!clientId) {
    clientId = crypto.randomUUID();
    clientIdStorage.set(clientId);
  }
  return clientId;
}

export function ensureClientIdPosted() {
  const clientId = getOrCreateClientId();
  const isClientIdPosted = clientIdPostedFlagStorage.get();

  if (isClientIdPosted) {
    return Promise.resolve(clientId);
  }

  if (postPromise) {
    return postPromise.then(() => clientId);
  }

  postPromise = common
    .postClientId(clientId)
    .then(res => {
      if (!res) return;
      if (res?.data?.Data?.isSuccess) {
        clientIdPostedFlagStorage.set(true);
      } else {
        throw new Error('postClientId failed');
      }
    })
    .catch(error => console.error('postClientId error:', error))
    .finally(() => {
      postPromise = null;
    });

  return postPromise.then(() => clientId);
}
